// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PrescriberResponseModel } from './prescriberResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TenantPrescriberObjectData {
    'prescribers': Array<PrescriberResponseModel> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TenantPrescriberObjectData>> = [
        {
            "name":     "prescribers",
            "baseName": "prescribers",
            "type":     "Array<PrescriberResponseModel>"
        },
    ];

    static getAttributeTypeMap() {
        return TenantPrescriberObjectData.attributeTypeMap;
    }
}
